<template>
    <div
        v-on:click="clickHandler"
        class="custom-button"
        :class="{ active: active }"
    >
        {{ options.name }}
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Object,
            required: true,
        },
        current: {
            required: true,
            default: 0,
        },
    },
    data() {
        return {
            active: false,
        };
    },
    methods: {
        clickHandler(){
            (this.current === this.options.id)
                ? this.$emit("input", 0)
                : this.$emit("input", this.options.id);
        },
    },
    watch: {
        current(){
            this.active = (this.current === this.options.id);
        }
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/classes';

.custom-button{
    text-align: center;
    background-color: var(--pallete_degrade_start_color);
    /*border-radius: 25px;*/
    border: 1px solid var(--pallete_main_color);
    color: var(--background_03);
    cursor: pointer;
    user-select: none;
    width: 100%;
    height: 45px;
    line-height: 45px;
    transition: all 100ms ease-in-out;
    text-transform: capitalize;

    &.active {
        background-color: transparent;
        color: var(--pallete_main_color);
        box-shadow: 1px 1px 3px rgba(0, 0, 0, .5);
    }
    
    &:hover {
        color: var(--pallete_main_color);
        background-color: transparent;
        -webkit-transition: all 250ms linear;
        -ms-transition: all 250ms linear;
        transition: all 250ms linear;
    }
}
</style>
